<template>
  <transition name="fade" appear>
    <tbody>
      <slot></slot>
    </tbody>
  </transition>
</template>

<script>
export default {
  props: { skipGroupTransition: Boolean },
};
</script>
